import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';
import AntLayout from '../Layout';
import Routes from '../Routing';
import ChangePassword from 'pages/ChangePassword/ChangePassword';
import Login from 'components/Login';
import NotFound from 'pages/404';
import Error from 'pages/404/error';
import { useQuery } from 'react-query';
import { getCurrentUserMenu } from 'services/displayFramework';
import { isNil } from 'lodash';
import { message } from 'antd';

export const AuthContext = React.createContext({
  token: null,
  setToken: () => null,
  menu: [],
} as any);

const Auth: React.FC = () => {
  const [token, setToken] = useState(() => localStorage.getItem('token'));

  const [changePassword, setchangePassword] = useState(() =>
    localStorage.getItem('changepassword')
  );
  const [inspect, setInspect] = useState(false);

  const { data: menu, isFetching } = useQuery(
    ['getCrrentUserMenu', { token }],
    async () => await getCurrentUserMenu().then((res) => res?.list || []),
    { enabled: !isNil(token) }
  );

  const setTokenInLocal = (token: string) => {
    localStorage.setItem('token', token);
    setToken(token);
  };

  useEffect(() => {
    setchangePassword(localStorage.getItem('changepassword'));
    setToken(localStorage.getItem('token'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem('token'), localStorage.getItem('changepassword')]);

  const setInspectMode = (modeInspect: boolean) => {
    if (modeInspect === true) message.info('Ispect mode is ON', 5);
    else message.info('Inspect mode is OFF', 5);
    setInspect(modeInspect);
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        setToken: setTokenInLocal,
        menu: menu,
        isFetching,
        setInspectMode,
        isInspect: inspect,
      }}
    >
      
      <Router>
        <Switch>
          <Route exact path="/pageNotFound">
            <NotFound />
          </Route>
          <Route exact path="/404">
            <Error />
          </Route>
          <Route path="/init_change_password">
            <AntLayout>
              <ChangePassword isInit />
            </AntLayout>
          </Route>
          {token &&
          (changePassword === 'false' || changePassword == null) &&
          menu ? (
            <AntLayout>
              <Routes />
            </AntLayout>
          ) : (
            !(
              token &&
              (changePassword === 'false' || changePassword == null)
            ) && (
              <>
                <Route path="/login">
                  <Login />
                </Route>

               

                {changePassword === 'true' ? (
                  <Redirect
                    to={{
                      pathname: '/init_change_password',
                    }}
                  />
                ) : (
                  <Redirect
                    to={{
                      pathname: '/login',
                    }}
                  />
                )}
              </>
            )
          )}
        </Switch>
      </Router>
    </AuthContext.Provider>
  );
};

export default Auth;
